module.exports = __webpack_public_path__ + "media/images/pepsi_home/restaurant_pattern-76ab9e8103d9c5f7dc2b4fdbc9e23620.jpg";